module.exports = __webpack_public_path__ + "static/img/img1.fd45f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1.jpg
// module id = Eaaq
// module chunks = 0